// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetail from '../../containers/analytics/SecurityDetail';


const SecurityCriticalAcceptableDetail = ({ data }) => {

  return (
    <SecurityDetail
      data={data}
      criticality='critical'
      adequacy='acceptable'
    />
  );
};

SecurityCriticalAcceptableDetail.propTypes = {
  data: PropTypes.object.isRequired
};

export default SecurityCriticalAcceptableDetail;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityCriticalAcceptableDetail.js